"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var layout_utils_1 = require("../../utils/layout-utils");
var base_card_model_1 = require("../base-card.model");
var form_card_row_model_1 = require("./form-card-row.model");
var lodash_1 = require("lodash");
var FormCardModel = /** @class */ (function (_super) {
    __extends(FormCardModel, _super);
    function FormCardModel(visibility) {
        var _this = _super.call(this) || this;
        _this.visibility = visibility;
        _this.isNested = false;
        _this.formCardRows = [];
        return _this;
    }
    FormCardModel.prototype.addController = function (controller) {
        var newRow = new form_card_row_model_1.FormCardRowModel();
        newRow.appendController(controller);
        newRow.rowId = layout_utils_1.LayoutUtils.uniqueId();
        this.formCardRows.push(newRow);
    };
    FormCardModel.prototype.createNewRow = function () {
        var newRow = new form_card_row_model_1.FormCardRowModel();
        newRow.rowId = layout_utils_1.LayoutUtils.uniqueId();
        this.formCardRows.push(newRow);
        return newRow.rowId;
    };
    FormCardModel.prototype.insertControllerOnIndex = function (controller, indexToPush) {
        var newRow = new form_card_row_model_1.FormCardRowModel();
        newRow.rowId = layout_utils_1.LayoutUtils.uniqueId();
        newRow.appendController(controller);
        this.formCardRows.splice(indexToPush, 0, newRow);
    };
    FormCardModel.prototype.insertInRow = function (cell, rowId) {
        var rowToDropIn;
        for (var _i = 0, _a = this.formCardRows; _i < _a.length; _i++) {
            var row = _a[_i];
            if (row.rowId === rowId) {
                rowToDropIn = row;
                break;
            }
        }
        rowToDropIn.appendCell(cell);
        return rowId;
    };
    FormCardModel.prototype.insertInRowOnIndex = function (cell, rowId, index) {
        var rowToDropIn;
        for (var _i = 0, _a = this.formCardRows; _i < _a.length; _i++) {
            var row = _a[_i];
            if (row.rowId === rowId) {
                rowToDropIn = row;
                break;
            }
        }
        rowToDropIn.insertCellInIndex(cell, index);
        return rowId;
    };
    FormCardModel.prototype.insertInUpperRow = function (cell) {
        var newRow = new form_card_row_model_1.FormCardRowModel();
        newRow.rowId = layout_utils_1.LayoutUtils.uniqueId();
        this.formCardRows.splice(0, 0, newRow);
        newRow.appendCell(cell);
        return newRow.rowId;
    };
    FormCardModel.prototype.insertInLowerRow = function (cell, rowId) {
        var counter = 0;
        var rowToDropInIndex;
        for (var i = 0; i < this.formCardRows.length; i++) {
            counter += this.formCardRows[i].cells.length;
            if (this.formCardRows[i].rowId === rowId) {
                rowToDropInIndex = i + 1;
                break;
            }
        }
        var newRow = new form_card_row_model_1.FormCardRowModel();
        newRow.rowId = layout_utils_1.LayoutUtils.uniqueId();
        newRow.appendCell(cell);
        if (rowToDropInIndex === this.formCardRows.length) {
            this.formCardRows.push(newRow);
        }
        else {
            this.formCardRows.splice(rowToDropInIndex, 0, newRow);
        }
        return newRow.rowId;
    };
    FormCardModel.prototype.isTitleDefined = function () {
        return !lodash_1.isNil(this.title);
    };
    FormCardModel.prototype.titleFromMap = function (titleMap) {
        var keys = Object.keys(titleMap);
        var multilingualStringBuilder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
        keys.forEach(function (key) {
            multilingualStringBuilder.withValueForLanguage(Number(key), titleMap[key]);
        });
        this.title = multilingualStringBuilder.build();
    };
    FormCardModel.prototype.isCardEmpty = function () {
        return lodash_1.isEmpty(this.formCardRows);
    };
    return FormCardModel;
}(base_card_model_1.BaseCardModel));
exports.FormCardModel = FormCardModel;
//# sourceMappingURL=form-card.model.js.map